import { LogLevel, BOMConfig } from './types';

class BOMLogger {
  private static instance: BOMLogger;
  private prefix = '📋 [BOM]';

  private constructor() {
    // Private constructor to enforce singleton
  }

  public static getInstance(): BOMLogger {
    if (!BOMLogger.instance) {
      BOMLogger.instance = new BOMLogger();
    }
    return BOMLogger.instance;
  }

  public setPrefix(prefix: string): void {
    this.prefix = prefix;
  }

  public debug(message: string, ...args: any[]): void {
    if (BOMConfig.logLevel >= LogLevel.DEBUG) {
      console.debug(`${this.prefix} ${message}`, ...args);
    }
  }

  public info(message: string, ...args: any[]): void {
    if (BOMConfig.logLevel >= LogLevel.INFO) {
      console.log(`${this.prefix} ${message}`, ...args);
    }
  }

  public warn(message: string, ...args: any[]): void {
    if (BOMConfig.logLevel >= LogLevel.WARN) {
      console.warn(`${this.prefix} ${message}`, ...args);
    }
  }

  public error(message: string, ...args: any[]): void {
    if (BOMConfig.logLevel >= LogLevel.ERROR) {
      console.error(`${this.prefix} ${message}`, ...args);
    }
  }

  public trace(message: string, ...args: any[]): void {
    if (BOMConfig.logLevel >= LogLevel.DEBUG) {
      console.trace(`${this.prefix} ${message}`, ...args);
    }
  }

  public group(label: string): void {
    if (BOMConfig.logLevel >= LogLevel.DEBUG) {
      console.group(`${this.prefix} ${label}`);
    }
  }

  public groupEnd(): void {
    if (BOMConfig.logLevel >= LogLevel.DEBUG) {
      console.groupEnd();
    }
  }

  public startTimer(label: string): () => void {
    if (BOMConfig.logLevel >= LogLevel.DEBUG) {
      console.time(`${this.prefix} ${label}`);
      return () => console.timeEnd(`${this.prefix} ${label}`);
    }
    return () => {};
  }
}

export const logger = BOMLogger.getInstance();
